/**
 * @fileoverview GET handler for the "/engagement/canvases_with_replied_to_sms" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementCanvasesWithRepliedToSms } from "./constants";
import type { EngagementCanvasesWithRepliedToSmsResult } from "./types";

export const getEngagementCanvasesWithRepliedToSms = reactQueryFetcherAdapter(
  engagementCanvasesWithRepliedToSms,
  (
    signal: AbortSignal,
    appGroupId: string,
    query: string,
    limit: number,
    filterKey: string
  ): Promise<EngagementCanvasesWithRepliedToSmsResult> => {
    return fetch(
      "/engagement/canvases_with_replied_to_sms",
      "GET",
      { app_group_id: appGroupId, query, limit, filter_key: filterKey },
      { signal }
    );
  }
);
